module.exports = __webpack_public_path__ + "ef74ca84b11ae5bde676bd4cbef47f9b.jpg";